var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgText06(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 51,
    viewBox: "0 0 42 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3066"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.9,
    d: "M23.7109 3.64453V9.76953H8.07031V12.1211H22.125V17.918H8.07031V20.543C14.9062 20.5156 19.6914 20.4062 25.1875 19.5586L25.7344 25.7383C19.1172 26.668 13.4297 26.7227 4.24219 26.7227H0.304688V3.64453H23.7109ZM40.4453 0.964844V27.3789H32.625V17.5352H24.9141V11.3555H32.625V0.964844H40.4453ZM40.4453 29.0742V42.7461H14.7422V44.8789H41.7578V50.8945H6.8125V37.168H32.625V35.0898H6.8125V29.0742H40.4453Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText06);
export default __webpack_public_path__ + "static/media/text06.50cd639ef07f709f2fcf8433d588930f.svg";
export { ForwardRef as ReactComponent };